import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login, user, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) nav("/admin");
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welkom terug!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inp = "w-full bg-surface border border-border px-4 py-3.5 outline-none focus:border-primary transition-colors";

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between bg-primary text-white p-14 relative overflow-hidden grain">
        <Link to="/" className="font-display font-black text-2xl relative z-10">STOOF</Link>
        <div className="relative z-10">
          <h1 className="font-display font-black text-5xl tracking-tight leading-none uppercase">Beheer<br />omgeving</h1>
          <p className="mt-6 text-white/70 max-w-sm">Log in om occasions te beheren en aanvragen te bekijken.</p>
        </div>
        <p className="text-white/40 text-sm relative z-10">Automobielbedrijf Stoof — Vinkeveen</p>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="font-display font-bold text-3xl mb-2">Inloggen</h2>
          <p className="text-text-muted mb-8">Toegang tot het beheerdersdashboard.</p>
          <div className="space-y-4">
            <div>
              <label className="text-sm font-semibold">E-mail</label>
              <input data-testid="login-email" type="email" autoComplete="off" className={inp + " mt-2"} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mailadres" />
            </div>
            <div>
              <label className="text-sm font-semibold">Wachtwoord</label>
              <input data-testid="login-password" type="password" className={inp + " mt-2"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full rounded-full bg-primary text-white font-semibold px-7 py-4 hover:bg-primary-light transition-colors disabled:opacity-60">
              {loading ? "Bezig..." : "Inloggen"}
            </button>
          </div>
          <div className="flex items-center gap-3 my-6">
            <span className="h-px flex-1 bg-border" />
            <span className="text-xs uppercase tracking-widest text-text-muted">of</span>
            <span className="h-px flex-1 bg-border" />
          </div>
          <button type="button" onClick={googleLogin} data-testid="google-login-btn"
            className="w-full rounded-full border border-border bg-surface font-semibold px-7 py-4 hover:border-primary transition-colors flex items-center justify-center gap-3">
            <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
              <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"/>
              <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"/>
              <path fill="#FBBC05" d="M3.97 10.72a5.41 5.41 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z"/>
              <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.47.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"/>
            </svg>
            Inloggen met Google
          </button>
          <p className="text-xs text-text-muted text-center mt-3">Alleen voor beheerders met een toegestaan Google-account.</p>
          <Link to="/" className="block text-center text-sm text-text-muted hover:text-primary mt-6 transition-colors">← Terug naar website</Link>
        </form>
      </div>
    </div>
  );
}
